export default "__VITE_ASSET__Cp_zW8Lf__"